var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header"},[_c('LocaleSwitcher'),_c('Notification'),_c('div',{staticClass:"sp__1d5x"}),_c('UserMenu',{on:{"handleOpenEditUser":_vm.handleOpenEditUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }